import { FLAG_OPTIONS, NO_FLAG } from "./flagsConfig";

export default function flagsMenuItem(onUpdateWorkOrder) {
  const updateFlag =
    (flag) =>
    ({ eventRecord }) => {
      const {
        data: {
          block: { workOrder },
        },
      } = eventRecord;
      onUpdateWorkOrder({ flag, id: workOrder.id });
    };

  const flagsSubMenuItems = Object.keys(FLAG_OPTIONS).map((flagOption) => ({
    cls: `pendo-add-flag-context-menu-item flag-menu-item flag-${flagOption}`,
    onItem: updateFlag(flagOption),
    text: flagOption,
  }));
  flagsSubMenuItems.push({
    cls: "pendo-remove-flag-context-menu-item",
    onItem: updateFlag(NO_FLAG),
    text: "Remove flag",
  });

  return {
    menu: flagsSubMenuItems,
    name: "flags",
    text: "Flags",
  };
}
